/*
 * Toggle del upsell del cart drawer.
 *
 * El bloque .cart-upsell venia sin ningun JS: el checkbox era puro CSS (y nacia
 * `checked` aunque el producto no estuviera en el carrito, o sea que mentia), y
 * el <product-form> oculto que lo acompanaba reventaba con TypeError en
 * product-form.js:27 porque le faltaba el .loading__spinner que ese script da
 * por hecho. Aqui se habla directamente con /cart/add.js y /cart/change.js.
 *
 * DELEGACION EN document, no listener directo: cart.js:onCartUpdate reemplaza
 * .cart-drawer__footer entero con replaceWith(), asi que cualquier listener
 * enganchado al input se perderia en el primer repintado.
 *
 * Que producto se ofrece y si el toggle sale ON u OFF lo decide Liquid en
 * snippets/cart-drawer.liquid. Este archivo solo aplica el cambio.
 */
(function () {
  'use strict';

  var TOGGLE = '[data-cart-upsell-toggle]';
  var inFlight = false;

  function routeOr(key, fallback) {
    return (window.routes && window.routes[key]) || fallback;
  }

  function setBusy(input, busy) {
    inFlight = busy;
    input.disabled = busy;
    var root = input.closest('.cart-upsell');
    if (root) root.classList.toggle('is-busy', busy);
  }

  function announce(data) {
    // source distinto de 'cart-items' para que CartItems.onCartUpdate (cart.js)
    // repinte cart-drawer-items, .cart-drawer__footer y .drawer__header_all.
    // NO usar cart.renderContents(): cart-drawer.js llama a this.open() al final
    // y reabriria el drawer encima del usuario.
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-upsell', cartData: data });
    } else {
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }
  }

  function post(url, body) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body),
    }).then(function (response) {
      return response.json().then(function (data) {
        if (!response.ok) {
          throw new Error(data.description || data.message || 'Cart request failed');
        }
        return data;
      });
    });
  }

  function addUpsell(variantId) {
    // _upsell marca la linea como "metida por el widget". Lo usan la doble
    // pasada del listado y la seleccion del producto en Liquid.
    return post(routeOr('cart_add_url', '/cart/add') + '.js', {
      items: [{ id: Number(variantId), quantity: 1, properties: { _upsell: 'true' } }],
    });
  }

  function removeUpsell(lineKey, variantId) {
    // La key identifica la linea exacta; el variant id es el plan B por si
    // Liquid no la imprimio (no deberia pasar con el toggle en ON).
    return post(routeOr('cart_change_url', '/cart/change') + '.js', {
      id: lineKey || String(variantId),
      quantity: 0,
    });
  }

  document.addEventListener('change', function (event) {
    var input = event.target;
    if (!input || !input.matches || !input.matches(TOGGLE)) return;

    // Doble clic rapido: sin esto se crean dos lineas.
    if (inFlight) {
      input.checked = !input.checked;
      return;
    }

    var wanted = input.checked;
    var variantId = input.dataset.variantId;
    var lineKey = input.dataset.lineKey;
    if (!variantId) return;

    setBusy(input, true);

    var request = wanted ? addUpsell(variantId) : removeUpsell(lineKey, variantId);

    request
      .then(function (data) {
        announce(data);
      })
      .catch(function (error) {
        // Revertir: el carrito no cambio, el toggle no debe decir lo contrario.
        input.checked = !wanted;
        console.error('[cart-upsell]', error);
      })
      .finally(function () {
        setBusy(input, false);
      });
  });
})();
